import React from 'react';
import './Jumbotron.scss';
import { Link } from 'react-router-dom';
import SecondaryButton from '../Component/SecondaryButton';
import Headline from '../Component/Headline';

const Jumbotron = props => {
  return (
    <div className="jumbotron">
      <div className="container text-center">
        <div className="col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
          <div className="headline">
            <Headline
              headerTag="h1"
              headline="Nachbarn als Christkind-Helfer*innen"
              subline="2024 ist unsere Aktion zum 18. Mal unglaubliches Brauchtum an der Lutherkirche"
            />
          </div>
          <SecondaryButton title="WUNSCHLISTE" to="/list" size="lg" />
          <Link
            className="btn home-button-about btn-lg homeButton-About"
            to={'/howto'}
          >
            SO GEHT'S
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Jumbotron;



// WEBPACK FOOTER //
// ./src/Component/Jumbotron.js